// Import only leaf modules here, so services can import route names without the router.ts cycle (IGM-4148).
import { PRODUCT_AUTO_LOGIN_ROUTE } from '../../service/login/login-predicate';

export const MainRoute = {
  A11Y: 'erklaerung-zur-barrierefreiheit',
  ABOUT_US: 'about-us',
  ACCOUNT: 'account',
  /** In-app Cornucopia cashier (IGM-4082). `/cashier/{deposit,withdrawal}`. */
  CASHIER: 'cashier',
  CATEGORY: 'kategorie',
  CLUB1000: 'club1000',
  CONTACT_US: 'contact-us',
  DEPOSIT_BONUS: PRODUCT_AUTO_LOGIN_ROUTE,
  GAME_HISTORY: 'game-history',
  GAME: 'game',
  GAMES_INFO: 'games-info',
  GAMES: 'games',
  HELP_CENTER: 'help-center',
  HOME: '/',
  IMPRINT: 'impressum',
  INCENTIVE: 'challenges',
  INCENTIVE_REWARD: 'reward',
  LIMITS: 'account-limits',
  LOGIN_REQUIRED: 'login-required',
  LOGIN: 'user-login',
  LOGOUT: 'logout',
  MAINTENANCE: 'maintenance',
  NOTIFICATIONS: 'notifications',
  PAST_REWARDS: 'vergangen-boni',
  PAYMENTS_HISTORY: 'payments-history',
  PAYOUT: 'payout/step1',
  PROVIDER: 'anbieter',
  REWARDS: 'meine-boni',
  SEARCH: 'search',
  SHOW_GAMIFICATION_WIDGET: 'challenges',
  SITEMAP: 'sitemap',
  TAC: 'terms-and-conditions',
  TAG: 'tag',
  TERMS_OF_OFFER: 'angebotsbedingungen',
  THEMES: 'themes',
  WITHDRAWAL: 'withdrawal',
} as const;

/** Whether a root-relative navigo `Match.url` is on the in-app cashier (IGM-4148, IGM-4169). */
export function isCashierRouteUrl(url: string): boolean {
  return url.split('/')[0] === MainRoute.CASHIER;
}

/** Whether a root-relative navigo `Match.url` is the deposit bonus page, under any promotions slug (IGM-4188). */
export function isDepositBonusRouteUrl(url: string): boolean {
  return url.split('/')[1] === MainRoute.DEPOSIT_BONUS;
}

/** Whether a root-relative navigo `Match.url` is part of the deposit/withdrawal flow (IGM-4188). */
export function isPaymentFlowRouteUrl(url: string): boolean {
  return isCashierRouteUrl(url) || isDepositBonusRouteUrl(url);
}
